// src/index.ts
import { createIconGrid } from "@ex0/icon-grid";
import { defineApp } from "@ex0/kernel";
import { createContextMenu } from "@ex0/menu";

// src/icons.ts
var DEFAULT_ICON = "/icons/icon_001_64x64.png";
function getBuiltinIcons(kernel, iconMenu) {
  return kernel.getApps().filter((app) => !app.windowless && !app.protected).map((app) => ({
    id: app.id,
    label: app.name,
    iconSrc: app.icon ?? DEFAULT_ICON,
    onDoubleClick: () => kernel.spawn(app.id),
    onContextMenu: (e) => {
      e.preventDefault();
      e.stopPropagation();
      iconMenu.updateItems([
        { label: "Open", action: () => kernel.spawn(app.id) },
        { type: "separator" },
        { label: "Properties", disabled: true, action: () => {
        } }
      ]);
      iconMenu.show(e.clientX, e.clientY);
    }
  }));
}

// src/index.ts
var src_default = defineApp({
  id: "desktop",
  name: "Desktop",
  description: "Desktop background with icons and context menu",
  singleton: true,
  windowless: true,
  protected: true,
  mount(container, ctx) {
    const bg = document.createElement("div");
    bg.style.cssText = "position:absolute;inset:0;z-index:0;";
    container.appendChild(bg);
    const iconMenu = createContextMenu({ items: [] });
    const grid = createIconGrid({
      container: bg,
      icons: getBuiltinIcons(ctx.kernel, iconMenu)
    });
    const launchableApps = ctx.kernel.getApps().filter((app) => !app.windowless && !app.protected);
    const desktopMenu = createContextMenu({
      items: [
        ...launchableApps.map((app) => ({
          label: `New ${app.name}`,
          icon: app.icon ?? DEFAULT_ICON,
          action: () => ctx.kernel.spawn(app.id)
        })),
        { type: "separator" },
        {
          label: "Arrange Icons",
          children: [
            { label: "By Name", action: () => {
            } },
            { label: "Auto Arrange", action: () => {
            } }
          ]
        }
      ]
    });
    function onContextMenu(e) {
      e.preventDefault();
      desktopMenu.show(e.clientX, e.clientY);
    }
    bg.addEventListener("contextmenu", onContextMenu);
    return {
      dispose() {
        bg.removeEventListener("contextmenu", onContextMenu);
        grid.destroy();
        desktopMenu.destroy();
        iconMenu.destroy();
        bg.remove();
      }
    };
  }
});
export {
  src_default as default
};
